import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.styl']
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts